import { render, staticRenderFns } from "./zktlxcxx.vue?vue&type=template&id=3d54a472&scoped=true"
import script from "./zktlxcxx.vue?vue&type=script&lang=js"
export * from "./zktlxcxx.vue?vue&type=script&lang=js"
import style0 from "./zktlxcxx.vue?vue&type=style&index=0&id=3d54a472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54a472",
  null
  
)

export default component.exports